<template>
<div>

		<div v-if="selectedProduct">
		<single :product="selectedProduct"
				:property-definitions="propertyDefinitions"
				:filtered-products="filteredProducts"
		>
		</single>
		</div>

		<div class="container py-5 py-md-7" v-if="!selectedProduct">

			<div class="row filter-bar-desktop d-none d-md-flex mb-4">
				<div class="col-3">
					{{ filteredProducts.length }} produkter
				</div>

				<div class="col-3">
					<button type="button" class="btn btn-sm btn-light btn-remove-filter" v-if="filter.category" @click="filter.category = null">
						{{ filter.category.text }}
					</button>
				</div>

				<div class="col d-flex align-items-center justify-content-end">

					<div class="me-2">
						Sortera efter:
					</div>

					<div class="dropdown-wrapper">
						<button class="btn select-dropdown" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
							{{ sortActive.text }}
						</button>
						<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
							<li class="dropdown-item" v-for="option in sortOptions" @click="sortActive = option">{{ option.text }}</li>
						</ul>
					</div>

				</div>
			</div>

			<hr />

			<div class="d-flex justify-content-center align-items-center" style="height: 300px;" v-if="loading">
				<div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
					<span class="visually-hidden">Laddar...</span>
				</div>
			</div>

			<div class="row mt-5" v-if="!loading">
				<div class="col-0 col-md-3 filter-bar">
					<Filter :products="products" :filterOptions="filterOptions" v-model="filter" @mounted="() => (isMounted = true)" />
				</div>
				<div class="col-12 col-md-9">

						<div class="d-flex justify-content-center align-items-center" style="height: 300px;" v-if="filteredProducts.length === 0">
							Din sökning gav inga resultat.
						</div>

						<div id="product-grid-mascus" class="row article-row-cols row-cols-2 row-cols-md-3 g-3 g-md-4 gy-4">
							<div class="col mascus-product" v-for="product in limitedProducts" @click="selectedProduct = product">

								<div class="image-container">
									<img :src="product.attachments.attachment[0]['#text']" v-if="product.attachments && product.attachments.attachment[0]" />
								</div>

								<div class="title">
									{{ product.name }}
								</div>
								<!-- <div class="price" v-if="getProductAttribute(product, 'priceoriginal')">
									{{ getProductAttribute(product, 'priceoriginal') }} SEK
								</div> -->

								<div class="price" v-if="getProductAttribute(product, 'priceoriginal')">
									{{ getProductAttribute(product, 'priceoriginal') }} SEK <span style="font-size: 0.75rem;">exkl.moms</span>
								</div>
								<div class="info">
									{{ getProductAttribute(product, 'itemtype') }}<span v-if="getProductAttribute(product, 'itemtype') && getProductAttribute(product, 'yearofmanufacture')">, </span> {{ getProductAttribute(product, 'yearofmanufacture') }}
								</div>
								<div class="info">
									{{ getProductAttribute(product, 'location') }}
								</div>
							</div>
						</div>


						<div class="d-flex justify-content-center mt-5 mt-md-7">
							<div class="btn btn-outline-secondary" @click="show_num_products += 9" v-if="filteredProducts.length > show_num_products">
								Ladda fler produkter
							</div>
						</div>



				</div>
			</div>

		</div>
</div>
</template>

<script>
import axios from 'axios'
import { XMLParser } from "fast-xml-parser";


import { filterCategoriesMap } from './map'
import mixins from './mixins'

import single from './single'
import Filter from './filter'

export default {

	mixins: [mixins],

	components: {
		Filter,
		single,
	},

	props: {
		preselectedFilterCategory: {
			default: null
		}
	},

	data() {
		return {
			filterCategoriesMap: filterCategoriesMap,
			isMounted: false,
			xml: null,
			propertyDefinitions: [],
			products: [],

			sortOptions: [
				{text: 'Märke (A-Z)', attribute: 'brand', direction: 'asc'},
				{text: 'Märke (Z-A)', attribute: 'brand', direction: 'desc'},
				{text: 'Modell (A-Z)', attribute: 'model', direction: 'asc'},
				{text: 'Modell (Z-A)', attribute: 'model', direction: 'desc'},
				{text: 'Tillverkningsår (lägst först)', attribute: 'yearofmanufacture', direction: 'asc'},
				{text: 'Tillverkningsår (Fallande)', attribute: 'yearofmanufacture', direction: 'desc'},
				{text: 'Mätarst. (lägst först)', attribute: 'meterreadoutkilometers', direction: 'asc'},
				{text: 'Mätarst. (Fallande)', attribute: 'meterreadoutkilometers', direction: 'desc'},
				{text: 'Pris (lägst först)', attribute: 'priceoriginal', direction: 'asc'},
				{text: 'Pris (Fallande)', attribute: 'priceoriginal', direction: 'desc'},
				{text: 'Skapad (lägst först)', attribute: null, direction: 'asc'},
				{text: 'Skapad (Fallande)', attribute: null, direction: 'desc'},
			],
			sortActive: null,

			selectedProduct: null,

			filter: {
				text: '',
				category: null,
				brand: null,
				location: null,
				priceoriginal: {
					from: 0,
					to: 1
				},
				yearofmanufacture: {
					from: 0,
					to: 0,
				},
				meterreadouthours: {
					from: 0,
					to: 0,
				},
				categoryTree: []
			},

			filterOptions: {
				categories: [],
				brands: [],
				locations: [],
				min_yearofmanufacture: 0,
				max_yearofmanufacture: 0,
				maxPrice: 1,
				max_meterreadouthours: 0,
			},


			show_num_products: 9,

			loading: true
		}
	},

	created () {
		this.emitter.on('selectProduct', (product) => {
			this.selectedProduct = product
		})

		if (this.preselectedFilterCategory) {

			console.log('preselected filter')

			const category = this.filterCategoriesMap.find(c => c.text === this.preselectedFilterCategory)
			if (category) {
				console.log('category')
				console.log(category)

				this.filter.category = category
			}
		}

		this.sortActive = this.sortOptions[11]
		this.fetch()

		history.replaceState({ selectedProduct: false }, '', '');

		window.addEventListener("popstate", (event) => {
			console.log( `location: ${document.location}, state: ${JSON.stringify(event.state)}`)

			if (event.state && event.state.selectedProduct === false) {
				this.selectedProduct = null
			}
		})
	},

	watch: {
		scroll(val) {
			const [limitedProducts, isMounted] = val.split("|");
			console.log(isMounted);
			console.log(limitedProducts);

			if (limitedProducts.length > 0 && isMounted === "true") {
				const anchor = document.querySelector("#anchor");
				// $("html, body").animate(
				// 	{
				// 		scrollTop: anchor.getBoundingClientRect().top,
				// 	},
				// 	100,
				// );
			}
		},
		selectedProduct (val, oldVal) {
			console.log('selectedProduct')
			console.log(val)
			console.log(oldVal)

			if (!oldVal) {
				console.log('pushState')
				history.pushState({ selectedProduct: true }, '', '');
			} else {
				console.log('replaceState')
				console.log('selectedProduct = '+(val ? 'true' : 'false')+'')
				history.replaceState({ selectedProduct: val ? true : false }, '', '');
			}


			/* $('html, body').animate({
				scrollTop: $("#vue-mascus").offset().top
			}, 100); */
		},
		/* limitedProducts(val) {
			if (val.length > 0) {
				$('html, body').animate({
					scrollTop: $("#vue-mascus").offset().top
				}, 100);
			}
		} */
	},

	computed: {
		scroll() {
			return `${this.limitedProducts}|${this.isMounted}`;
		},
		limitedProducts () {
			return this.sortedProducts.slice(0, this.show_num_products)
		},

		sortedProducts () {
			if (this.sortActive?.text === 'Skapad (lägst först)' || this.sortActive?.text === 'Skapad (Fallande)') {
				return this.filteredProducts.sort((a, b) => {
					if (a.createdate < b.createdate) {
						return this.sortActive.direction === 'asc' ? -1 : 1;
					}
					if (a.createdate > b.createdate) {
						return this.sortActive.direction === 'asc' ? 1 : -1;
					}
					return 0
				})
			}

			return this.filteredProducts.sort((a, b) => {
				if (this.getProductAttribute(a, this.sortActive.attribute) < this.getProductAttribute(b, this.sortActive.attribute)) {
					return this.sortActive.direction === 'asc' ? -1 : 1;
				}
				if (this.getProductAttribute(a, this.sortActive.attribute) > this.getProductAttribute(b, this.sortActive.attribute)) {
					return this.sortActive.direction === 'asc' ? 1 : -1;
				}
				return 0
			})
		},

		filteredProducts () {
			// if (!this.filter.category && !this.filter.text && !this.filter.brand && !this.filter.location) {
			// 	return this.products
			// }

			const filteredProducts = []
			this.products.forEach(product => {
				let passed = true

				if (product.expirydate) {
					console.log('product.expirydate = ' +product.expirydate)
				}


				if (this.filter.category && this.filter.category.contains.indexOf(product.custom.category) === -1) {
					console.log('this filter category')
					passed = false
				}

				if (this.filter.text && product.name.toLowerCase().indexOf(this.filter.text.toLowerCase()) === -1) {
					console.log('this filter text')
					passed = false
				}

				if (this.filter.brand && this.filter.brand.text !== this.getProductAttribute(product, 'brand')) {
					console.log('this filter brand')
					passed = false
				}

				if (this.filter.location && this.filter.location.text !== this.getProductAttribute(product, 'location')) {
					console.log('this filter location')
					passed = false
				}

				const priceoriginal = this.getProductAttribute(product, 'priceoriginal')
				if (this.filter.priceoriginal.from > priceoriginal || this.filter.priceoriginal.to < priceoriginal) {
					console.log('this filter price')
					passed = false
				}

				const yearofmanufacture = this.getProductAttribute(product, 'yearofmanufacture')
				if ((this.filter.yearofmanufacture.from > this.filterOptions.min_yearofmanufacture || this.filter.yearofmanufacture.to < this.filterOptions.max_yearofmanufacture) && (this.filter.yearofmanufacture.from > yearofmanufacture || this.filter.yearofmanufacture.to < yearofmanufacture)) {
					console.log('this filter yearofmanufacture')
					passed = false
				}

				const meterreadouthours = this.getProductAttribute(product, 'meterreadouthours')
				if (this.filter.meterreadouthours.from > meterreadouthours || this.filter.meterreadouthours.to < meterreadouthours) {
					console.log('this filter meterreadouthours')
					passed = false
				}

				if (passed) {
					filteredProducts.push(product)
				}
			})

			console.log('is filtered products running?')

			return filteredProducts
		}
	},

	methods: {

		parseFilterOptions() {
			this.products.forEach(p => {
				const price = parseInt(this.getProductAttribute(p, 'priceoriginal'))
				if (price > this.filterOptions.maxPrice) {
					this.filterOptions.maxPrice = price
				}

				const brand = this.getProductAttribute(p, 'brand');
				const brandIndex = this.filterOptions.brands.findIndex(b => b.text === brand)
				if (brandIndex === -1) {
					this.filterOptions.brands.push({text: brand, num_ads: 1})
				} else {
					this.filterOptions.brands[brandIndex].num_ads++
				}

				const location = this.getProductAttribute(p, 'location');
				const locationIndex = this.filterOptions.locations.findIndex(l => l.text === location)
				if (locationIndex === -1) {
					this.filterOptions.locations.push({ text: location, num_ads: 1 })
				}  else {
					this.filterOptions.locations[locationIndex].num_ads++
				}

				const yearOfManufacture = this.getProductAttribute(p, 'yearofmanufacture');
				const regex = new RegExp(/^\d{4}$/);
				if (yearOfManufacture && regex.test(yearOfManufacture)) {
					if (yearOfManufacture < this.filterOptions.min_yearofmanufacture || this.filterOptions.min_yearofmanufacture === 0) {
						this.filterOptions.min_yearofmanufacture = yearOfManufacture
					}
					if (yearOfManufacture > this.filterOptions.max_yearofmanufacture || this.filterOptions.max_yearofmanufacture === 0) {
						this.filterOptions.max_yearofmanufacture = yearOfManufacture
					}
				}

				const meterreadouthours = parseInt(this.getProductAttribute(p, 'meterreadouthours'))
				if (meterreadouthours > this.filterOptions.max_meterreadouthours) {
					this.filterOptions.max_meterreadouthours = meterreadouthours
				}
			})

			this.filter.yearofmanufacture.from = this.filterOptions.min_yearofmanufacture
			this.filter.yearofmanufacture.to = this.filterOptions.max_yearofmanufacture

			this.filter.priceoriginal.to = this.filterOptions.maxPrice

			this.filter.meterreadouthours.to = this.filterOptions.max_meterreadouthours
		},

		fetch () {
			const ajaxUrl = window.ajax_url


			axios({
				method: 'get',
				url: ajaxUrl + '?action=mg_mascus_fetch',
			})
				.then((response) => {
					console.log('mg_mascus_fetch result')
					console.log(response.data)

					this.loading = false

					if (response.data.status === 'ok') {
						const options = {
							ignoreAttributes: false,
							attributeNamePrefix : "_",
							isArray: (name, jpath, isLeafNode, isAttribute) => {
								if([
									'mascusexport.catalogs.categories.category',
									'mascusexport.catalogs.catalog.categories.category',
									'mascusexport.catalogs.catalog.categories.category.products.product',
									'mascusexport.catalogs.catalog.categories.category.products.product.sellers',
									'mascusexport.catalogs.catalog.categories.category.products.product.attachments.attachment'
								].indexOf(jpath) !== -1) return true;
							}
						};
						const parser = new XMLParser(options);

						const xml = parser.parse(response.data.xml);

						this.xml = xml

						xml.mascusexport.catalogs.catalog.forEach(catalog => {
							if (!Array.isArray(catalog.categories.category)) {
								return
							}

							const catalogIndex = this.filterOptions.categories.push({
								text: catalog.displayname,
								children: [],
								num_products: 0,
							})

							catalog.categories.category.forEach(category => {
								if (Array.isArray(category.propertydefinitions.property)) {
									category.propertydefinitions.property.forEach(property => {
										if (this.propertyDefinitions.findIndex(p => p._name === property._name) === -1) {
											this.propertyDefinitions.push(property)
										}
									})
								}
								if (Array.isArray(category.products.product)) {
									category.products.product.forEach(product => {

										product.custom = {
											catalog: catalog.name,
											category: category.name
										}

										this.products.push(product)
									})
								}
							})
						})

						this.parseFilterOptions()
					}
				})
				.catch((error) => {
					console.log('error')
					console.log(error)
					if (error.response && error.response.data) {
						// errorMsg = error.response.data.message
					}
				})
		},
	}
}
</script>
